import { render, staticRenderFns } from "./MaterialParameters.vue?vue&type=template&id=58abb62c&scoped=true"
import script from "./MaterialParameters.vue?vue&type=script&lang=js"
export * from "./MaterialParameters.vue?vue&type=script&lang=js"
import style0 from "./MaterialParameters.vue?vue&type=style&index=0&id=58abb62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58abb62c",
  null
  
)

export default component.exports